import styled from 'styled-components';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import Box from 'component/layoutComponents/Box';


export const StyledProgressTask = styled(Box)`
  ${({ theme }: { theme: typeof DefaultUptimeTheme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .MuiLinearProgress-root {
        height: 7px;
        border-radius: 8px;
        width: 140px;
    }
  `}
`;
